import React from 'react';
import ReactDOM from 'react-dom';
import $  from 'jquery';
import Icons from './icons';
import TrackingActions from 'medscape/tracking';
const pageLink = 'twitter-widget';
export default class twitterWidgetModule extends React.Component{
	constructor(props) {
		super(props);
		
	}
	componentDidMount() {
		let $this = $(ReactDOM.findDOMNode(this));
		TrackingActions.trackContainerLinks($this[0]);
		$.getScript( "https://platform.twitter.com/widgets.js", ( data, textStatus, jqxhr ) => {
			this.initTwitter();
		});
    }
    initTwitter(){
    	window.twttr.ready((twttr)=>{
    		// Track user clicking Twitter's iframe
			window.addEventListener('blur',function(){
			      if(document.activeElement.id.startsWith("twitter-widget")){
			        TrackingActions.pageLink(pageLink);
			      }
			});
			/*
			twttr.events.bind('click',function(ev){
				TrackingActions.pageLink(pageLink);
			});
			*/
		});
    }
    getIcon(){  
    	let icon;
    	return icon = (<Icons.twitter />);
    }
	render(){
		let accountName = "https://twitter.com/"+ this.props.account;
		let limitNumber = this.props.limitNumber;
		let urlName = this.props.account;
		let icon = this.getIcon();
		let aProps = {
                onClick: (e) => { 
                	e.preventDefault();
                	let url = $(e.currentTarget).attr('href');
                	window.open(url, "shareWindow", "width=600, height=400, scrollbars=no");
                	TrackingActions.pageLink(pageLink);            	
                },
                href: `https://twitter.com/${urlName}/following`
            }
        let timelineProps = {
        	"className": "twitter-timeline",
        	"href": accountName,
        	"data-chrome": "nofooter noheader transparent",
        	"data-tweet-limit": limitNumber,
        }
		return (
			<div className = "twitter-container">
				<div className ="twitter-header">
					<h4>Follow us @ {urlName}</h4>
					<div className="mysvg">
						<a{...aProps}>{ icon }</a>
					</div>
				</div>
				<ul className="twitter-container">
			    	<a {...timelineProps} ></a>
		    	</ul>
			</div>
			);
	}
}

twitterWidgetModule.propTypes ={
	"account" : React.PropTypes.string,
	"limitNumber" : React.PropTypes.string
}


// WEBPACK FOOTER //
// ./medscape_modules/twitter-widget/app.jsx